<script setup lang="ts">
const siteUrl = useSiteUrl()

import { useSeoMeta } from '#app'

useSeoMeta({
  title: 'تبادل ارز سریع و امن با کمترین کارمزد',
  titleTemplate: 'پی جیب | %s',

  description:
    'تبادل ارز و انتقال آن به تمامی نقاط جهان با سرعت بالا، امنیت کامل و کمترین کارمزد. انتقال ارز در چند مرحله ساده و سریع. همین حالا شروع کنید!',

  robots: 'index,follow',

  ogTitle: 'تبادل ارز سریع و امن با کمترین کارمزد',
  ogDescription:
    'تبادل ارز و انتقال آن به تمامی نقاط جهان با سرعت بالا، امنیت کامل و کمترین کارمزد. انتقال ارز در چند مرحله ساده و سریع. همین حالا شروع کنید!',
  ogImage: siteUrl('/payjib.webp'),
  ogUrl: siteUrl('/'),
  ogType: 'website',
  ogSiteName: 'پی‌جیب',
  ogLocale: 'fa_IR',

  twitterCard: 'summary_large_image',
  twitterTitle: 'تبادل ارز سریع و امن با کمترین کارمزد',
  twitterDescription:
    'تبادل ارز و انتقال آن به تمامی نقاط جهان با سرعت بالا، امنیت کامل و کمترین کارمزد. انتقال ارز در چند مرحله ساده و سریع. همین حالا شروع کنید!',
  twitterImage: siteUrl('/payjib.webp'),
})
</script>
<template>
  <div class="w-full h-full overflow-x-hidden">
    <div class="rtl w-full">
      <HomeHeroSection />
      <!--      <HomeBannerSection />-->
      <BaseSocialMediaSection />
      <HomeStepsSection />
      <HomeCurrencyExchangeSection />
      <HomeServicesSection />
      <HomeCommentsSection />
      <HomeAppPromotionSection />
      <HomePayjibAudienceSection class="flex lg:hidden" />
      <HomeRegistrationSection />
      <HomeHistorySection />
      <HomePayjibAudienceSection class="hidden lg:flex" />
      <HomeSupportSection />
      <HomeCounselingSection />
      <HomeBlogSection />
      <HomeSecondRegistrationSection />
      <HomeQuestionsSection />
    </div>
    <HomeConsultationRequestModal />
  </div>
</template>

<style scoped>
.container {
  padding: 0;
  width: 100%;
  max-width: 1088px;
}
</style>
